import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CreditCardForm from '../payments/parts/CreditCardForm';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 500,
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  px: 4,
  py: 3
};

const validateFields = (values) => {
  const errors = {};
  const cleanedCardNumber = values.cardNumber.replace(/\s+/g, '');

  if (!/^\d{13,19}$/.test(cleanedCardNumber)) {
    errors.cardNumber = 'Invalid card number';
  }

  const month = parseInt(values.month, 10);
  if (!values.month || isNaN(month) || month < 1 || month > 12) {
    errors.month = 'Invalid month';
  }

  const year = parseInt(values.year, 10);
  if (!values.year || isNaN(year) || year < 23 || year > 99) {
    errors.year = 'Invalid year';
  }

  if (!/^\d{3}$/.test(values.cvv)) {
    errors.cvv = 'CVV must be 3 digits';
  }

  return errors;
};

const CustomPaymentDialog = ({
  open,
  onClose,
  amount,
  accountantId,
  caseId,
  userType,
  token,
  onSuccess,
  onError
}) => {
  const { t, i18n } = useTranslation();
  const dir = i18n.dir();
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({
    cardNumber: '',
    month: '',
    year: '',
    cvv: '',
    holder: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const formatCardNumber = (input) =>
      input
        .replace(/\D/g, '')
        .replace(/(.{4})/g, '$1 ')
        .trim();

    setValues((prev) => ({
      ...prev,
      [name]: name === 'cardNumber' ? formatCardNumber(value) : value
    }));

    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handlePay = async () => {
    const fieldErrors = validateFields(values);
    if (Object.keys(fieldErrors).length > 0) {
      setErrors(fieldErrors);
      return;
    }

    const cleanedCardNumber = values.cardNumber.replace(/\s+/g, '');

    const paymentData = {
      UserId: accountantId,
      UserType: userType,
      Amount: amount,
      CardNumber: cleanedCardNumber,
      ExpiryMonth: +values.month,
      ExpiryYear: +values.year,
      CVV: values.cvv,
      CardHolderId: values.holder || null,
      Items: [{
        Name: t('XtramAccountingSystem') || 'Xtram מערכת הנהלת חשבונות',
        Type: 'I',
        UnitPrice: amount,
        UnitsNumber: 1
      }]
    };

    onSuccess(paymentData);
  };

  const isFormValid = Object.keys(validateFields(values)).length === 0;

  return (
    <Modal open={open} onClose={onClose} disableEscapeKeyDown>
      <Box sx={modalStyle} dir={dir}>
        <Typography variant="h6" gutterBottom>
          {t('CompleteYourPayment') || 'השלם את התשלום'}
        </Typography>

        <DialogContent dividers>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            {t('Amount') || 'סכום'}: ₪{amount?.toFixed(2)}
          </Typography>

          <CreditCardForm
            values={values}
            onChange={handleChange}
            disabled={false}
            errors={errors}
          />
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <Button
            onClick={handlePay}
            variant="contained"
            color="primary"
            disabled={!isFormValid}
          >
            {t('PayNow') || 'שלם עכשיו'}
          </Button>
          <Button onClick={onClose}>
            {t('cancel') || 'ביטול'}
          </Button>
        </DialogActions>
      </Box>
    </Modal>
  );
};

export default CustomPaymentDialog;
